import React, { forwardRef, LegacyRef } from 'react'

import styles from '../style.module.less'
import { BaseIconProps } from '../types'

export const Table = forwardRef(
  (
    { _width, _height, _fill, className, spin, rtl, ...rest }: BaseIconProps,
    root: LegacyRef<SVGSVGElement>
  ) => {
    return (
      <svg
        ref={root}
        width={_width}
        height={_height}
        viewBox="0 0 48 48"
        preserveAspectRatio="xMidYMid meet"
        fill="none"
        role="presentation"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ''} ${spin ? styles.spin : ''} ${
          rtl ? styles.rtl : ''
        }`.trim()}
        {...rest}
      >
        <g>
          <defs>
            <clipPath id="bb40c__a">
              <rect
                rx="0"
                height="48"
                width="48"
              />
            </clipPath>
          </defs>
          <g clipPath="url(#bb40c__a)">
            <path
              fillRule="evenodd"
              d="M3 24V7q0-1.657 1.172-2.828Q5.343 3 7 3h34q1.657 0 2.828 1.172Q45 5.343 45 7v34q0 1.657-1.172 2.828Q42.657 45 41 45H7q-1.657 0-2.828-1.172Q3 42.657 3 41V24Zm4 2v15h15V26H7Zm19 15h15V26H26v15Zm15-19V7H26v15h15ZM22 7v15H7V7h15Z"
              data-follow-fill="#455766"
              fill={_fill}
            />
          </g>
        </g>
      </svg>
    )
  }
)
